const endpoints = {
  createRemunerationsGoal: (): string => `remuneration/goal`,
  showRemunerationGoal: (id: string): string => `remuneration/goal/${id}`,
  inactivateRemunerationGoal: (id: string): string =>
    `remuneration/goal/inactivate/${id}`,
};

export default endpoints;
